<template>
  <div id="app">
    <h2>Make your life count</h2>
    <hr />
    <div class="counter-list">
      <counter 
      v-for="(date,i) in counterData" 
      :key="i" 
      :date="date" 
      :index="i" 
      :sexy="sexy" 
      :maxLifeTime="maxLifeTime"
      :scroll="scrolling" 
      />
      <div class="more">
        <span v-for="i in 3" :key="i"></span>
        <i>Treasure every moment you have</i>
      </div>
    </div>
    <commit />
    <div class="copyright">
      Designed by Vicco Wang @ 2019
    </div>
  </div> 
</template>
<script>
import { lifeExpectancy, throttle } from './utils'
import Counter from './components/counter'
import Commit from './components/commit'

export default {
  name: 'app',
  data () {
    return {
      country: 'China',
      sexy: 0,
      counterData: [
        '1950',
        '1960',
        '1970',
        '1980',
        '1990',
        '2000',
        '2010',
      ].reverse(),
      time: '',
      scrolling: null
    }
  },
  computed: {
    maxLifeTime () {
      const country = lifeExpectancy[this.country]
      return this.sexy === 0 ? country['male'] : country['female']
    }
  },
  mounted () {
    document.addEventListener('scroll', throttle(this.initScrollHandle, 50) )
  },
  methods: {
    initScrollHandle(event) {
      this.scrolling = event.timeStamp
    } 
  },
  components: {
    Counter,
    Commit
  }
}
</script>

<style lang="scss">
html, body {
  background-color: #fff;

  ul, li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding-top: 30px;
  margin: 0 auto;
  max-width: 1000px;
  user-select: none;

  h2 {
    position: relative;
    display: inline-block;
    width: 100%;
    margin: 0;
    font-size: 3rem;
    font-style:italic;
    font-weight: 200;
    color: rgb(245, 58, 120);
    box-sizing: border-box;
  }

  hr {
    width: 100%;
    padding: 0;
    margin:30px 0;
    border: 1px dashed rgb(226, 226, 226);
    // background-color: rgb(226, 226, 226);

  }

  .counter-list {
    margin: 10px 0;
    display: grid;
    background:rgb(236, 236, 236);
    grid-template-columns: 1fr;
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    // outline: 1px solid rgb(212, 212, 212);

    > div {
      background-color: #fff;

      &.more {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 0 35px 0;
        font-size: 1.5rem;
        font-weight: 200;
        color: gray;

        span {
          display: block;
          width: 5px;
          height: 5px;
          clear:both;
          background: gray;
          border-radius: 100%;
          margin: 20px 0;
        }
      }
    }
  }

  
  
  .copyright {
    padding: 35px 0 15px 0;
    color: rgb(172, 172, 172);
    font-size: .7rem;
  }


  
  @media screen and ( max-width: 640px) { 
    h2 {
      font-size: 2rem;
    }

    hr {
      margin-bottom: 0;
    }

    .counter-list {

      > div {
       &.more { font-size: 1.1rem; }
      }
    }
  }
}

</style>
